import timeSec from '#utilities/js/ea/timeSec.js'
import { handle } from './wrapper.js'

const { parseInt } = Number

const handler = (quantity, unit, delay) => {
  const quantityValue = parseInt(quantity.value, 10)

  delay.value = quantityValue * timeSec[unit.value]
}

export default element => {
  handle(element, handler)
}